module.exports = __webpack_public_path__ + "img/about-logo.d4f9f965.png";